import { makeChartComp } from '../../util/makeChartComp';
var RoseChart = makeChartComp('Rose');
export default RoseChart;
